import { isPlatformBrowser, NgFor, NgIf } from '@angular/common';
import { Component, Inject, Input, OnInit, PLATFORM_ID, ViewChild } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatStepperModule } from '@angular/material/stepper';
import { FuseCardComponent } from '@fuse/components/card';
import { ICustomer, iDebitOrderMandate, IEntityAttachment, ILead, IOrder, IResponse } from 'app/core/shared-services/shared-interface.types';
import { SharedMethodsModule } from 'app/core/shared-services/shared-methods.module';
import { DebitOrdersComponent } from 'app/modules/financials/debit-orders/debit-orders.component';
import { CancelOrderComponent } from '../debit-order-options/cancel-order/cancel-order.component';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { FuseAlertComponent, FuseAlertType } from '@fuse/components/alert';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { UpfrontPaymentComponent } from 'app/modules/financials/upfront-payment/upfront-payment.component';
import { SharedServiceService } from 'app/core/shared-services/shared-service.service';
import { CancelServiceComponent } from '../package-options/cancel-service/cancel-service.component';
import { WebStorage } from 'app/core/shared-services/web.storage';
import { Router } from '@angular/router';
import { forEach } from 'lodash';

@Component({
  standalone: true,
  selector: 'app-orders',
  templateUrl: './orders.component.html',
  styleUrls: ['./orders.component.scss'],
  imports: [
    FuseCardComponent, MatIconModule, MatProgressSpinnerModule, ReactiveFormsModule,
     MatSelectModule, MatDialogModule, MatInputModule, FuseAlertComponent, MatButtonModule, NgFor, 
     NgIf, MatStepperModule, DebitOrdersComponent, UpfrontPaymentComponent]
})
export class OrdersComponent implements OnInit {
  // ## VARS ##
  @Input() orderList: IOrder[];
  @Input() customerAccount: ICustomer;
  public debitOrderMandate: iDebitOrderMandate;
  public debitOrders: IOrder[] = [];

  private leadEntityID: number;
  private packageValidationComplete: any;
  private specialProductOverviewResult: any;
  private specialProductActions: Array<any> = []; 
  private actionPayload: any = {};
  private executeProductActionResult: any;
  public executeProductAction: any = {};
  public renderProductAction: any = {};
  public specialProductSelected: any;
  private subActionExecutionResult: any;
  public subActionLoading: boolean = false;
  public productActionLoading: boolean = false;
  @ViewChild('specialProductsModal') specialProductsModal: any;
  @ViewChild('specialProductsPreConfirmationTextModal') specialProductsPreConfirmationTextModal: any;
  private addressActionForm: any = {};
  public preConfirmationText: string;

  public alert: { type: FuseAlertType; message: string };
  public showAlert: boolean = false;
  public showSpecialProdutsAlert: boolean = false;

  private getLinkedOfferables: any;

  public uploadedProof: boolean = false;
  public uploadedId: boolean = false;

  public actionsLoading: boolean;

  constructor(
    public _sharedMethods: SharedMethodsModule,
    private dialog: MatDialog,
    private _fb: FormBuilder,
    private _sharedService: SharedServiceService,
    private _webStorage: WebStorage,
    private router: Router,
    @Inject(PLATFORM_ID) private platformId: any,
  ){}

  // ## HOOKS ##
  async ngOnInit() {
    await this.loadOrders();

    // see if account has document
    if (this.customerAccount) {
      await this.getAllAttachments();
    }
  }

  // ## METHODS ##
  private async loadOrders() {
    this.debitOrders = [];
    this.orderList.forEach(async (element: IOrder) => {
    await this._sharedMethods.getUpfrontAmountDue(element.LeadEntityID).then(async (res)=>{    
      element["upFrontAmount"] = res.result;
      await this._sharedMethods.getLinkedOfferablesByLeadId(element.LeadEntityID).then((data: any) => {
        if (data.success) {
          data.result.forEach(el => {
            if(el?.OfferableSubTypeName && el.OfferableSubTypeName.includes('FTTH')) {
                element["isFibre"] = true;
            }
          })
        }
      })

      
  
      if(element.DebitOrderMandateRequired){
        await this._sharedMethods.getDebitOrder(element.LeadEntityID).then((res: IResponse) => {
          if (res.success) {
            this.debitOrderMandate = res?.result?.find(el => el.Status === 'Pending' || el.Status === 'Accepted');
            element.debitOrderMandate = this.debitOrderMandate;
            this.debitOrders.push(element);
          }
        })
      }else{
        this.debitOrders.push(element);
      }
      })
    });
    this.debitOrders.sort((a, b) => a.LeadEntityID - b.LeadEntityID);
  }

  public async cancelOrder(data) {
    this.actionsLoading = true;
    if(data.LeadStatus == "UpfrontPaid"){
      this._sharedService.activeCustomerServices = data;
      this.dialog.open(CancelServiceComponent, {
        width: '800px',
        backdropClass: 'blurModalBackground'
      });
    }else{
      this.dialog.open(CancelOrderComponent, {
        width: '80vw',
        height: 'auto',
        backdropClass: 'blurModalBackground',
        data: {
          debitOrder: data
        }
      }).afterClosed().subscribe(async (res) => {
        
        this.actionsLoading = false;
        window.location.reload();
        
        // BREAKING CHANGE
        // const index = this.debitOrders.findIndex(order => order.LeadEntityID === data?.LeadEntityID);
        // this.debitOrders.splice(index, 1);
      });
    }
  }

  public openSpecialProducts(leadId: number) {
    this.leadEntityID = leadId;
    this.dialog.open(this.specialProductsModal, {
      width: '500px',
      backdropClass: 'blurModalBackground',
      disableClose: true
    });
    this.specialProductLogic();
  }

  public specialProductSelection(event: any) {
    this.specialProductSelected = event.value;
  }

  public async executeProductSubAction(actionKey: string, subActionKey: string, inputParamKey: string, preConfirmationText?: string) {
    if(preConfirmationText) {
      this.preConfirmationText = preConfirmationText;
      this.dialog.open(this.specialProductsPreConfirmationTextModal, {
        width: '500px',
        backdropClass: 'blurModalBackground',
        disableClose: true
      });
    }
    this.subActionLoading = true;
    this.actionPayload[inputParamKey] = this.specialProductSelected?.value;

    this.subActionExecutionResult = await this._sharedMethods.executeSpecialProductSubAction(this.leadEntityID, this.packageValidationComplete.result[0].Metadata.item_id, actionKey, subActionKey, this.actionPayload);

    if (this.subActionExecutionResult.result.Successful) {

      this.alert = { type:'success', message: this.subActionExecutionResult.result.ActionResponseData };
      this.showAlert = true;



      this.specialProductLogic();
      this.subActionLoading = false;

    } else {
      this.alert = { type: 'error', message: this.subActionExecutionResult.result.ActionResponseData };
      this.showAlert = true;

      this.subActionLoading = false;

    }
  }

  public async executeRenderProductAction(actionKey: string) {
    this.productActionLoading = true;

    if (this.addressActionForm.value.redirect_url == null && isPlatformBrowser(this.platformId)) {

      this.addressActionForm.value.redirect_url = window.location.origin + '/'
    }
    this.executeProductActionResult = await this._sharedMethods.executeSpecialProductAction(this.leadEntityID, this.packageValidationComplete.result[0].Metadata.item_id, actionKey, this.addressActionForm.value);	

    if (this.executeProductActionResult.result.ErrorMessage) {
      this.alert = { type:'error', message: this.executeProductActionResult.result.ErrorMessage };
      this.showSpecialProdutsAlert = true;
      this.productActionLoading = false;

    } else {
      this.productActionLoading = false;
      this.specialProductLogic();
    }
  }

  public async completeOrder(data) {
    
    localStorage.setItem('LeadEntityId', data.LeadEntityID);
    this.getLinkedOfferables = await this._sharedMethods.getLinkedOfferablesByLeadId(data.LeadEntityID);
    this.getLinkedOfferables.result.forEach(async element => {
      if (element.Billing_IsRecurring) {
        const addPackage = await this._webStorage.UpdateCart('add', element, data.LeadEntityID);
        if (addPackage) {
          this.router.navigate(['/cart']);
        }
      }
    });
  }

  // -----------------------------------------------------------------------------------------------------
// @ Private methods
// -----------------------------------------------------------------------------------------------------
 
 

  private async specialProductLogic() {
    this.packageValidationComplete = await this._sharedMethods.packageCompletionValidate(this.leadEntityID);
    if(this.packageValidationComplete.success) {
      this.specialProductOverviewResult = await this._sharedMethods.getSpecialProductOverview(this.leadEntityID, this.packageValidationComplete.result[0].Metadata.item_id);
      this.specialProductActions = [];
      this.specialProductOverviewResult.result?.ActionAvailability.Actions.forEach(async actions => {
        this.specialProductActions.push(actions);
      });

      this.specialProductActions.forEach(async spa => {
        if (spa.ClientSideExecutionType === 'Terminate') {
          return
        }
        if(spa.ClientSideExecutionType === 'Selection') {
          if (spa.InputParameters.length) {
            this.actionPayload[spa.InputParameters[0].ParamKey] = spa.InputParameters[0].ParamValue;
            this.executeProductActionResult = await this._sharedMethods.executeSpecialProductAction(this.leadEntityID, this.packageValidationComplete.result[0].Metadata.item_id, spa.ActionKey, this.actionPayload);	
            if (this.executeProductActionResult.result) {
              this.executeProductAction = {
                ClientSideInstruction: this.executeProductActionResult.result.ClientSideInstruction,
                ClientSideInstructionData: this.executeProductActionResult.result.ClientSideInstructionData,
                ErrorMessage: this.executeProductActionResult.result.ErrorMessage,
              }
            }
          } else {
            this.executeProductActionResult = await this._sharedMethods.executeSpecialProductAction(this.leadEntityID, this.packageValidationComplete.result[0].Metadata.item_id, spa.ActionKey, {});	
            if (this.executeProductActionResult.result) {
              this.executeProductAction = {
                ClientSideInstruction: this.executeProductActionResult.result.ClientSideInstruction,
                ClientSideInstructionData: this.executeProductActionResult.result.ClientSideInstructionData,
                ErrorMessage: this.executeProductActionResult.result.ErrorMessage,
              }
            }
          }
        }
        if(spa.ClientSideExecutionType === 'Render') {

          if (spa.InputParameters.length) {
            this.addressActionForm = this._fb.group({});

            spa.InputParameters.forEach(async inputParam => {

              this.addressActionForm.addControl(inputParam.ParamKey, this._fb.control(inputParam.ParamValue, inputParam.Required ? Validators.required : null));

              return this.addressActionForm;
            })
          } else {
            this.executeProductActionResult = await this._sharedMethods.executeSpecialProductAction(this.leadEntityID, this.packageValidationComplete.result[0].Metadata.item_id, spa.ActionKey, {});	
            this.renderProductAction = {
              ClientSideInstruction: this.executeProductActionResult.result.ClientSideInstruction,
              ClientSideInstructionData: this.executeProductActionResult.result.ClientSideInstructionData,
              ErrorMessage: this.executeProductActionResult.result.ErrorMessage,
            }
          }
        }
      })
    }
  }

  private async getAllAttachments() {
    await this._sharedMethods.getAllAttachments(this.customerAccount?.EntityAccountEntityID).then((res: IResponse) => {
      if (res?.success) {
        const proofAttachments: IEntityAttachment[] = [];
        const idAttachments: IEntityAttachment[] = [];
        const attachments: IEntityAttachment[] = res?.result?.Attachments;
        attachments.filter(element => {
          if(element?.Notes === "PROOFOFRESIDENCE"){
            proofAttachments.push(element);
          }
          if(element?.Notes === "IDDOCUMENT"){
            idAttachments.push(element);
          }
        });
        const proofAttachment:IEntityAttachment = proofAttachments.sort((a, b) => Number(new Date(b.CreatedDate)) - Number(new Date(a.CreatedDate)))[0];
        const IdAttachment:IEntityAttachment = idAttachments.sort((a, b) => Number(new Date(b.CreatedDate)) - Number(new Date(a.CreatedDate)))[0];
        this.uploadedProof = proofAttachment ? true : false;
        this.uploadedId = IdAttachment ? true : false;
      }
    });
  }


  public goToRica(){
    this.router.navigateByUrl('/dashboard/profile#rica');
  }
}







